import type { ReactNode } from 'react'

import { Stack } from './Stack'
import { Text } from './Text'
import { TextLink } from './TextLink'

export function Section({
  title,
  more,
  children,
}: {
  title: string
  more?: { to: string; label: string }
  children: ReactNode
}) {
  return (
    <Stack as="section" gap="sm">
      <Stack direction="row" justify="between" gap="sm">
        <Text as="h2" role="eyebrow" tone="muted">
          {title}
        </Text>
        {more ? <TextLink to={more.to}>{more.label}</TextLink> : null}
      </Stack>
      {children}
    </Stack>
  )
}
